module.exports = __webpack_public_path__ + "img/lens-167-minus-12.8a2124a2.png";